module.exports = __webpack_public_path__ + "static/img/news0.f7b2647.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news0.png
// module id = +qOJ
// module chunks = 0